import { Component, OnDestroy, OnInit } from '@angular/core';
import { WishlistServiceProvider } from "../../providers/wishlist-service/wishlist-service";
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { Analysis, RequestUser, WishlistAdd, WishlistRemove, WishlistGet, SearchRequest, Venue } from "../../models/models";
import { LoadingController, IonInfiniteScroll, IonItemSliding, ToastController, AlertController } from '@ionic/angular';
//import { trigger, state, style, animate, transition } from '@angular/animations';
import { UserDataProvider } from '../../providers/user-data/user-data';
import { RefdataProvider } from '../../providers/refdata/refdata'
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { BeerDetailPage } from '../../pages/beer-detail/beer-detail';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BeerDetailPage_PATH } from '../../app/app-constants';

@Component({
  selector: 'wishlist',
  templateUrl: 'wishlist.html',
  styleUrls: ['./wishlist.scss'],
  standalone: false,
//  imports: [
//    IonicModule,
//    CommonModule,
//    FormsModule,
//    TranslateModule
//  ]
})

export class WishlistComponent implements OnInit, OnDestroy {
  public beers: Array<any> = [];
  private pageNumber: number = 0;
  private rowCount: number = 20;
  private fetchMore: boolean = true;

  private sortFilter: any = {sortField: "name", direction: "ASC"};

  private selectedVenue = null;

  isLoading: Array<any> = [];
  loading: any = null;

  sortfilterChangedSubscription: any;
  venueSelectedSubscription: any;
  venueDeselectedSubscription: any;
  deleteBeerSubscription: any;

  constructor(
    private wishlistService: WishlistServiceProvider,
    private locationProvider: LocationServiceProvider,
    private router: Router,
    private userData: UserDataProvider,
    private refdata: RefdataProvider,
    private bhutil: BhutilProvider,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private locationService: LocationServiceProvider,
    private translateService: TranslateService,
    private events: AppEventService,
    private storage: Storage
  ) {
  }

  ngOnInit() {
    console.log("wishlist - ngOnInit")
    this.locationProvider.showInfo();

    this.userData.init().then(() => {
      this.storage.get('selected-venue').then((venue) => {
        // First read the selected venue from storage
        let venueJSON = JSON.parse(venue);
        if (venueJSON != null) {
          this.selectedVenue = venueJSON;
          console.log("wishlist - currently venue with id selected: " + venueJSON.id);
        }

        this.loadNext(false, null);
      });

      this.sortfilterChangedSubscription = (sortFilter: any) => {
        console.log("wishlist - noticed filter changed to:", sortFilter);
        this.sortFilter = sortFilter;
        this.refresh();
      };
      this.events.subscribe("sortfilter:changed", this.sortfilterChangedSubscription);

      this.venueSelectedSubscription = (venue: Venue) => {
        console.log("wishlist - noticed filter veneu changed to:", venue.id);
        this.selectedVenue = venue;
        this.refresh();
      };
      this.events.subscribe("venue:selected", this.venueSelectedSubscription);

      this.venueDeselectedSubscription = () => {
        console.log("wishlist - noticed filter veneu changed to: null");
        this.selectedVenue = null;
        this.refresh();
      };
      this.events.subscribe("venue:deselected", this.venueDeselectedSubscription);

      this.deleteBeerSubscription = (deleteBeer) => {
        console.log("my-anaylyses - deleting beer with id", deleteBeer.removalId);
        this.delete(deleteBeer.item, deleteBeer.beer, deleteBeer.removalId);
      }
      this.events.subscribe("delete:beer", this.deleteBeerSubscription);
    });

  }

  ngOnDestroy() {
    console.log("wishlist - ngOnDestroy")
    this.events.unsubscribe("venue:deselected", this.venueDeselectedSubscription);
    this.events.unsubscribe("sortfilter:changed", this.sortfilterChangedSubscription);
    this.events.unsubscribe("venue:selected", this.venueSelectedSubscription);
    this.events.unsubscribe("delete:beer", this.deleteBeerSubscription);
  }


  loadNext(isScroll: boolean, infiniteScroll: IonInfiniteScroll) {
    console.log('[my-analyses] - loadNext');

    if (!this.fetchMore) {
      if (isScroll) {
        infiniteScroll.complete();
      }
      return;
    }

    this.pageNumber++;

    if (!isScroll) {
      this.isLoading.push(true);
      if (this.isLoading.length > 1) {
        this.executeLoad(isScroll, infiniteScroll);
      } else {
        let loadingProm = this.createLoading();
        loadingProm.then((ld) => {
          this.loading = ld;
          this.loading.present().then(() => {
            this.executeLoad(isScroll, infiniteScroll);
          });
        });
      }
    } else {
      this.executeLoad(isScroll, infiniteScroll);
    }
  }

  executeLoad(isScroll, infiniteScroll) {
    this.userData.getUserID()
      .then((userID) => {
        //userID = "5"
        let wishlistGet = new WishlistGet(userID, this.locationProvider.latitude, this.locationProvider.longitude, this.rowCount, this.pageNumber, this.sortFilter.sortField, this.sortFilter.direction, (this.selectedVenue ? this.selectedVenue.id : null));

        console.dir("WISHLIST - wishlist get for userID " + userID);
        console.dir(wishlistGet);

        this.wishlistService.getWishList(wishlistGet).subscribe(resp => {
          //console.log("[WISHLIST][GET] - response for wishlist: " + this.bhutil.stringify(resp));
          console.log("[WISHLIST][GET][2]");
          if (resp) {
            resp.forEach(element => {
              this.beers.push(element);
            });
            if (resp.length == 0) {
              this.fetchMore = false;
            }
          }
          else {
            console.log("[WISHLIST] - No response: weird");
          }

          if (isScroll) {
            infiniteScroll.complete();
          } else {
            this.stopLoading();
          }
        }, err => {
          console.log(err);
          if (isScroll) {
            infiniteScroll.complete();
          } else {
            this.stopLoading();
          }
        });
      });
  }

  showBeerDetail(b: any) {
    console.log("TODO: show details for beer " + this.bhutil.stringify(b));
    console.log("beerID is " + b.beer.id);
    // navigate to the detail screen, with the info preloaded
    this.router.navigate([ BeerDetailPage_PATH ], { state: { data: {
        'beer': b,
        'sourcetype': 'wishlist',
        'sourceID': 3
      }}});
  }

  buy(item: any) {
    console.log("buy an item");
    item.close();
  }

  delete(item: any, beer: any, removalId: any) {
    console.log("remove an item");
    let theBeerId = removalId;
    let beerName = beer.name;

    let alertProm = this.alertCtrl.create({
      header: this.translateService.instant("WISHLIST.DELETE_WISHLIST_ITEM"),
      message: this.translateService.instant("WISHLIST.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ITEM_FROM_YOUR_WISHLIST"),
      backdropDismiss: false,
      buttons: [
        {
          text: this.translateService.instant("GENERAL.NO"),
          role: 'cancel',
          handler: () => {
            console.log('No clicked');
            this.expandAction(item, 'not deleting item from wishlist', this.translateService.instant("GENERAL.DELETE_ACTION_CANCELLED"));
          }
        },
        {
          text: this.translateService.instant("GENERAL.YES"),
          handler: () => {
            console.log('Yes clicked');
            this.userData.getUserID()
              .then((userID) => {
                let wishtlistRemove: WishlistRemove = new WishlistRemove(userID, this.locationService.latitude, this.locationService.longitude, theBeerId);
                this.wishlistService.removeFromWishlist(wishtlistRemove).subscribe(resp => {
                  console.log("[wishlist-button] Resp for removeFromWishlist: " + this.bhutil.stringify(resp));
                  item.close();
                  this.expandAction(item, 'removing item from wishlist', this.translateService.instant("WISHLIST.BEER") + " " + beerName + " " + this.translateService.instant("WISHLIST.WAS_REMOVED_FROM_YOUR_WISHLIST"));

                  // add a short timeout to prevent the issue with "removeView"
                  setTimeout(() => {
                    this.refresh();
                  }, 500);

                }, err => console.log("remove from wishlist ERROR: " + err.error));
              })
              .catch((e) => {
                console.log("[wishlist-button][removeFromWishlist] failed => " + e);
                item.close();
                this.expandAction(item, 'removing item from wishlist', this.translateService.instant("WISHLIST.DELETE_ACTOIN_FAILED_TRY_AGAIN_LATER"));
              });
          }
        }
      ]
    });
    alertProm.then((alert) => alert.present());
  }

  refresh() {
    // refresh the list
    this.pageNumber = 0;
    this.fetchMore = true;

    let isScroll = false;

    this.beers = [];

    this.isLoading.push(true);
    if (this.isLoading.length > 1) {
      this.executeRefresh();
    } else {
      let loadingProm = this.createLoading();
      loadingProm.then((ld) => {
        this.loading = ld;
        this.loading.present().then(() => {
          this.executeRefresh();
        });
      });
    }


  }

  executeRefresh() {
    this.userData.getUserID()
    .then((userID) => {
      //userID = "5"
      let wishlistGet = new WishlistGet(userID, this.locationProvider.latitude, this.locationProvider.longitude, this.rowCount, this.pageNumber, this.sortFilter.sortField, this.sortFilter.direction, (this.selectedVenue ? this.selectedVenue.id : null));

      console.dir("WISHLIST - wishlist get for userID " + userID);
      console.dir(wishlistGet);

      this.wishlistService.getWishList(wishlistGet).subscribe(resp => {
        //console.log("[WISHLIST][GET] - response for wishlist: " + this.bhutil.stringify(resp));
        console.log("[WISHLIST][GET][2]");
        //console.dir(resp);
        if (resp) {
          resp.forEach(element => {
            this.beers.push(element);
          });
          if (resp.length == 0) {
            this.fetchMore = false;
          }
        }
        else {
          console.log("[WISHLIST] - No response: weird");
        }
        this.stopLoading();
      }, err => {
        console.log(err);
        this.stopLoading();
      });
    });
  }

  expandAction(item: IonItemSliding, _: any, text: string) {
    setTimeout(() => {
      const toastProm = this.toastCtrl.create({
        message: text
      });
      toastProm.then((toast) => {
        toast.present();
        setTimeout(() => toast.dismiss(), 2000);
      });
      item.close();
    }, 150);
  }

  getImageUrl(b: any) {
    if (b.beer.logo !== undefined && b.beer.logo != null) {
      let logoUrlBeer = this.refdata.getEnvVar('beerLogoBaseUrl') + b.beer.logo;
      return logoUrlBeer;
    } else if (b.beer.brewery.logo !== undefined && b.beer.brewery.logo != null) {
      let logoUrlBrewery = this.refdata.getEnvVar('breweryLogoBaseUrl') + b.beer.brewery.logo;
      return logoUrlBrewery;
    }
    else {
      let logoNoLogo = "../assets/svg/icon_beerglass.svg";
      return logoNoLogo;
    }
  }

  doInfinite(infiniteScroll) {
    console.log('[my-analyses] - doInfinite');
    this.loadNext(true, infiniteScroll);
  }

  createLoading(): Promise<HTMLIonLoadingElement> {
    return this.loadingCtrl.create({
      message: this.translateService.instant('GENERAL.PLEASE_WAIT')
    });
  }

  stopLoading() {
    this.isLoading.pop();
    if (this.isLoading.length == 0) {
      this.loading.dismiss();
    }
  }

  getValueStr(b: any, value: string) {
    let v = eval("b.beer." + value);
    if (v && v != "") {
      v = Math.round(v * 10) / 10;
      if (value == "abv") {
        v += "%";
      }
      return v + " " + this.translateService.instant("ADDBEER." + value.toUpperCase());
    }
  }

  hasAtLeastOneValue(beer: any) {
    return beer.abv || beer.ibu || beer.ebc;
  }
}
